export default {
  signIn: {
    username: {
      placeholder: 'Enter your email address (lowercase)',
      label: 'Email Address *',
      isRequired: true,
    },
    password: {
      label: 'Password *',
      placeholder: 'Enter your Password',
      isRequired: true,
    },
  },
  forgotPassword: {
    username: {
      label: 'Email Address *',
      placeholder: 'Enter your email address (lowercase)',
      isRequired: true,
    },
  },
  confirmResetPassword: {
    confirmation_code: {
      placeholder: 'Enter code',
      label: 'Verification code',
      isRequired: true,
    },
    password: {
      placeholder: 'New Password',
      label: 'New Password',
      isRequired: true,
    },
    confirm_password: {
      placeholder: 'Confirm Password',
      label: 'Confirm Password',
      isRequired: true,
    },
  },
}
